module.exports = __webpack_public_path__ + "static/media/PM26.87e06532.png";